import "./styles/reset.css";
import "./styles/overrides.scss";
import "./styles/styles.scss";
import "isuppli-react-components/dist/isuppli-bootstrap.css";
import "isuppli-react-components/dist/index.css";
import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import App from "./App";

const baseUrl = document.getElementsByTagName("base")[0].getAttribute("href") ?? undefined;
const rootElement = document.getElementById("root");

ReactDOM.render(
  <BrowserRouter basename={baseUrl}>
    <App />
  </BrowserRouter>,
  rootElement
);
